import { render, staticRenderFns } from "./NovaPoshtaTableMobile.vue?vue&type=template&id=74dcc030&scoped=true"
import script from "./NovaPoshtaTableMobile.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dcc030",
  null
  
)

export default component.exports